import { useState } from "react";
import { Keyboard } from "lucide-react";
import { useI18n } from "@/lib/i18n/i18n";

/** Manual fallback when a QR cannot be read (damaged screen, no camera). */
export const ManualCodeForm = ({ onSubmit, disabled, dark = false, testPrefix }) => {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");
  const { t } = useI18n();
  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} className={`flex h-11 w-full items-center justify-center gap-2 rounded-xl text-xs font-semibold transition-colors ${dark ? "bg-white/[0.06] text-white/80 hover:bg-white/10" : "border border-slate-200 text-slate-700 hover:border-slate-900"}`} data-testid={`${testPrefix}-manual-toggle`}>
        <Keyboard className="h-3.5 w-3.5" /> {t("Introducir código manualmente")}
      </button>
    );
  }
  const submit = (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    onSubmit(code.trim());
    setCode("");
  };
  return (
    <form onSubmit={submit} className="flex gap-2" data-testid={`${testPrefix}-manual-form`}>
      <input autoFocus value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="UPV-P-XXXXXXXX" maxLength={40}
        className={`h-11 min-w-0 flex-1 rounded-xl px-4 font-mono text-sm outline-none ${dark ? "bg-white/10 text-white placeholder:text-white/40" : "border border-slate-200 bg-white"}`} data-testid={`${testPrefix}-manual-input`} />
      <button type="submit" disabled={disabled} className="h-11 rounded-xl bg-upv px-4 text-xs font-bold text-white disabled:opacity-60" data-testid={`${testPrefix}-manual-submit`}>{t("Registrar")}</button>
    </form>
  );
};
